import { FormControl, MenuItem, useMediaQuery } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Button } from 'components/common/button';
import { InputLabel } from 'components/common/input-label';
import { Select } from 'components/common/select';
import { selectSetCountry, selectPaymentData, setCountryAsync } from 'features/payment/payment-slice';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

const SelectCountry = () => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery('(min-width:1024px)');
  const paymentData = useAppSelector(selectPaymentData);
  const { loading } = useAppSelector(selectSetCountry);
  const [country, setCountry] = useState<string>('');
  const dispatch = useAppDispatch();

  return (
    <div className={styles.country}>
      <div className={styles.country_content}>
        <div className={styles.country_content_box}>
          <div className={styles.country_content_select}>
            <InputLabel>{t('paymentMethod.selectCountry')}</InputLabel>
            <FormControl fullWidth>
              <Select
                displayEmpty
                fullWidth
                name="country"
                value={country}
                onChange={e => setCountry(e.target.value as string)}
              >
                <MenuItem disabled value="">
                  <em>{t('paymentInfo.country')}</em>
                </MenuItem>
                {paymentData?.availableCountries?.map((co, idx) => (
                  <MenuItem key={idx} value={co}>
                    {t(`countryCode.${co}`)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className={styles.country_content_button}>
            <Button
              color="primary"
              variant="contained"
              fullWidth
              loading={loading}
              square={!isDesktop}
              disabled={!country}
              onClick={() => dispatch(setCountryAsync(country))}
            >
              {t('common.next')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectCountry;
